/**
 * Вход в систему — §7.
 *
 * В демо роль переключалась кнопкой без пароля, и это было честно помечено
 * как временная заглушка. Здесь настоящий вход: сервер проверяет пароль и
 * заводит сессию.
 */

import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../api/queries.js';
import { Button } from '../components/ui.js';

export function Login() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const mutation = useLogin();
  const navigate = useNavigate();

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError(null);
    try {
      await mutation.mutateAsync({ login: login.trim(), password });

      /*
       * После входа — ВСЕГДА в заказы, а не туда, где были до выхода.
       *
       * Окно входа подменяет собой всю программу, но адрес в строке браузера
       * остаётся прежним. Сотрудник, вышедший со страницы «Сотрудники», после
       * входа возвращался на неё же — и упирался в «доступно только владельцу»,
       * будто его не пустили. Заказы — рабочий экран, с них начинают день.
       */
      navigate('/orders', { replace: true });
    } catch (err) {
      // Сервер намеренно не различает неверный логин, неверный пароль и
      // блокировку — показываем его текст как есть.
      setError(err instanceof Error ? err.message : 'Не удалось войти');
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm rounded-xl p-6 shadow-sm"
        style={{ background: 'var(--otc-surface)', border: '1px solid var(--otc-line)' }}
      >
        <p className="font-display text-lg font-bold text-ink">OrthoTechLab</p>
        <p className="mb-5 text-sm text-ink2">Зуботехническая лаборатория</p>

        <label className="mb-3 block">
          <span className="mb-1 block text-xs font-medium text-ink2">Логин</span>
          <input
            className="otc-input"
            value={login}
            onChange={(event) => setLogin(event.target.value)}
            autoComplete="username"
            autoFocus
          />
        </label>

        <label className="mb-4 block">
          <span className="mb-1 block text-xs font-medium text-ink2">Пароль</span>
          <input
            className="otc-input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
          />
        </label>

        {error && (
          <p className="mb-3 text-sm" style={{ color: 'var(--otc-coral)' }} role="alert">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={mutation.isPending || !login.trim() || !password}
          className="w-full rounded-lg py-2.5 text-sm font-medium text-white disabled:opacity-40"
          style={{ background: 'var(--otc-accent)' }}
        >
          {mutation.isPending ? 'Вход…' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
